import * as React from 'react';
import {Company} from "../../../../domain/model/company";

import Progress from "../../../common/organism/progress";
import {Project} from "../../../../domain/model/project";
import ClientProjectPreviewComponent from "./client_project_preview";
import ClientProjectModifyComponent from "./client_project_modify";
import ClientProjectCreateComponent from "./client_project_create";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    mode: string;
    project: Project | null;
    company: Company | null;
    handleUpdateProjectSubmit: (values: any) => void;
    handleCreateProjectSubmit: (values: any) => void;
}

const ClientProjectComponent: React.FC<IProps> = (props) => {

    const {isInit, isLoading, mode, project, company, handleUpdateProjectSubmit, handleCreateProjectSubmit} = props;

    // 初期化
    if (mode !== "create" && isInit) { return <Progress canAnimation={false}/>}

    let res: JSX.Element;

    switch (mode) {
        // project編集
        case "modify": {
            res = <ClientProjectModifyComponent
                isLoading={isLoading}
                project={project}
                handleUpdateProjectSubmit={handleUpdateProjectSubmit}/>;

            break;
        }

        // projectプレビュー
        case "preview": {

            res = <ClientProjectPreviewComponent
                isLoading={isLoading}
                project={project}
                company={company}/>;
            break;
        }

        // project新規作成
        case "create": {
            res = <ClientProjectCreateComponent
                handleCreateProjectSubmit={handleCreateProjectSubmit}
              />;

            break;
        }

        default:
            return (
                <div/>
            )
    }

    return res

};

export default ClientProjectComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/client_project.tsx